var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.47 26.53l-1.34-.26a23.33 23.33 0 0122.8-18.14v1.34A22 22 0 009.47 26.53z",
    fill: "#A7E2F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M30.93 50.53c7.3 0 13.2-.3 13.2-.66 0-.37-5.9-.67-13.2-.67-7.29 0-13.2.3-13.2.67 0 .37 5.91.66 13.2.66z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.94 50.27c10.75 0 19.46-8.48 19.46-18.94 0-10.45-8.71-18.93-19.46-18.93-10.76 0-19.47 8.48-19.47 18.93 0 10.46 8.71 18.94 19.47 18.94z",
    fill: "#A7E2F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.47 12.4h-.8l-1.34 1.33c-.13.27-.13.54-.4.8v2.14a1.2 1.2 0 01-1.06 1.2 1.2 1.2 0 00-1.2 1.06v2c-.03.31-.17.6-.4.8a.93.93 0 01-.8.4 1.2 1.2 0 00-1.2 1.07 1.2 1.2 0 001.2 1.2h.8l.4.27 8.13 7.73c.2.23.5.37.8.4h13.73c.31-.03.6-.17.8-.4 0-.53.14-1.07.14-1.47a18.67 18.67 0 00-18.8-18.53zM22 33.47h-.53a1.6 1.6 0 01-1.6-1.34v-.93a1.47 1.47 0 00-.4-1.07 1.07 1.07 0 00-1.07-.4H16a1.2 1.2 0 01-.93-.4l-1.74-1.73a1.47 1.47 0 00-1.06-.4H12a14.67 14.67 0 00-.53 4.13A19.07 19.07 0 0023.2 48.8c.25-.35.4-.77.4-1.2V34.93a1.47 1.47 0 00-1.46-1.46H22zM49.2 37.33l-8-.4c-.27 0-.27.14-.4.27l-4 3.47v.8a.53.53 0 00.13.4L40.8 46a.53.53 0 01.13.4c0 .13 0 .13-.13.27l-1.87 2a19.2 19.2 0 0010-9.74l.4-1.6h-.13z",
    fill: "#77D9F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.47 20h22.26V8.13H33.47V20z",
    fill: "#A7E2F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.47 20h22.26V8.13H33.47V20zm.93-8.13a3.33 3.33 0 003.2-2.8h14a3.47 3.47 0 003.2 2.8v4.4a3.33 3.33 0 00-3.2 2.8h-14a3.33 3.33 0 00-3.2-2.8v-4.4z",
    fill: "#485CC7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.53 16.13a2 2 0 100-4 2 2 0 000 4z",
    fill: "#485CC7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M.27 40.27h22.26V28.53H.27v11.74z",
    fill: "#A7E2F9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M.27 40.27h22.26V28.53H.27v11.74zm.8-8a3.33 3.33 0 003.2-2.8H18.4a3.47 3.47 0 003.2 2.8v4.4a3.2 3.2 0 00-3.2 2.66h-14a3.2 3.2 0 00-3.2-2.66l-.13-4.4z",
    fill: "#485CC7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.33 36.4a2 2 0 100-4 2 2 0 000 4z",
    fill: "#485CC7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 17.67,
    y1: 49.88,
    x2: 43.97,
    y2: 49.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.37382eef6f7d8d5ab8a7f8ac677d75d7.svg";
export { ForwardRef as ReactComponent };